import { isShowMode } from "./showMode";

const SHOW_ACCESS_STORAGE_KEY = "zeroco2_show_access_granted";
const SHOW_ACCESS_PASSWORD = "Tr3zzan0";

// 2026-06-01 00:00:00 Europe/Berlin (CEST, UTC+2)
const SHOW_PUBLIC_UNLOCK_AT_MS = Date.parse("2026-05-31T22:00:00.000Z");
export const SHOW_PUBLIC_UNLOCK_LABEL = "01.06.2026 (Europe/Berlin)";

function canUseStorage() {
  return typeof window !== "undefined" && !!window.localStorage;
}

export function isShowPublicUnlocked(nowMs = Date.now()): boolean {
  return Number.isFinite(SHOW_PUBLIC_UNLOCK_AT_MS) && nowMs >= SHOW_PUBLIC_UNLOCK_AT_MS;
}

export function isShowAccessRequired(): boolean {
  return isShowMode && !isShowPublicUnlocked();
}

export function hasShowAccessGrant(): boolean {
  if (!isShowAccessRequired()) return true;
  if (!canUseStorage()) return false;
  try {
    return window.localStorage.getItem(SHOW_ACCESS_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function tryGrantShowAccess(password: string): boolean {
  if (!isShowAccessRequired()) return true;
  if (password !== SHOW_ACCESS_PASSWORD) return false;
  if (!canUseStorage()) return true;
  try {
    window.localStorage.setItem(SHOW_ACCESS_STORAGE_KEY, "1");
  } catch {
    // Ignore storage failures; session still proceeds in-memory.
  }
  return true;
}

export function clearShowAccessGrant(): void {
  if (!canUseStorage()) return;
  try {
    window.localStorage.removeItem(SHOW_ACCESS_STORAGE_KEY);
  } catch {
    // Ignore storage cleanup failures.
  }
}
